var Profile = {
    Init: () => {
        if(document.querySelector(".js-profile-edit-back-btn")) {
            Profile.Edit();
        }

        Profile.Counter();
        Profile.FormImageSelect();
    },
    Counter: () => {
        const counterUp = window.counterUp.default;

        const els = document.querySelectorAll(".js-count-up");

        if(els) {
            els.forEach((el) => {
                if(el.classList.contains("js-responsive-font")) {
                    setTimeout(() => {
                        el.classList.add("is-visible");
                        counterUp( el, {
                            duration: 2500,
                            delay: 32
                        } )
                    }, 500)
                } else {
                    counterUp( el, {
                        duration: 2500,
                        delay: 16
                    } )
                }
            })
        }
    },
    Edit: () => {
        const backBtns = document.querySelectorAll("button.js-profile-edit-back-btn");
        const openBtns = document.querySelectorAll(".js-profile-edit-open-btn");
        const profileEdit = document.getElementById("js-profile-edit");

        backBtns.forEach((backBtn) => {
            backBtn.addEventListener("click", (e) => {
                e.preventDefault();

                profileEdit.classList.remove("is-visible");
            });
        });

        openBtns.forEach((openBtn) => {
            openBtn.addEventListener("click", (e) => {
                e.preventDefault();

                profileEdit.classList.add("is-visible");

                if(openBtn.classList.contains("js-profile-edit-open-btn--nav")) {
                    document.body.classList.remove("is-nav-open")
                }
            });
        });
    },
    FormImageSelect: () => {

        const imageSelect = document.getElementById("js-form-image-select");

        if(imageSelect) {
            const closeBtn = document.getElementById("js-form-pick-avatar-close-btn");
            const openBtn = document.getElementById("js-form-image-select-choose-btn");
            const image = document.getElementById("js-form-image-select-media");
            const imageOptions = document.querySelectorAll("img.js-form-image-select-option");
            const input = document.getElementById("js-form-image-select-input");

            openBtn.addEventListener("click", (e) => {
                e.preventDefault();

                imageSelect.classList.add("is-active");
            });

            closeBtn.addEventListener("click", (e) => {
                e.preventDefault();

                imageSelect.classList.remove("is-active");
            });

            imageOptions.forEach((imageOption) => {
                imageOption.addEventListener("click", (e) => {
                    e.preventDefault();
                    input.value = imageOption.src;
                    image.src = imageOption.src;
                    imageSelect.classList.remove("is-active");
                })
            })
        }
    }
}

Profile.Init();